import fieldTypes from '../../../../../../enums/FieldTypes';
import restrictChineseCharacters from '../../../../../form/field-validation/restrictChineseCharacters';
import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import PredictionsByField from '../../PredictionsByField';
import * as required from '../../required-validators';
import validateAutocompleteField from '../../validateAutocompleteField';
import caPostcode from '../../validationByCountry/Canada/ca-postcode';

const states = PredictionsByField.county('CA');

const formatCAPostcode = (value) => {
  if (value) {
    const trimmedToUpper = value.toUpperCase().replace(/\s/g, '');

    return trimmedToUpper && trimmedToUpper.length > 3
      ? `${trimmedToUpper.slice(0, 3)} ${trimmedToUpper.slice(3)}`
      : value;
  }
  return value;
};

const FieldDefinitionCADefault = [
  {
    ...addressee,
    validate: [required.fullName, max.lengthAddressee(35), restrictChineseCharacters],
  },
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    transform: formatCAPostcode,
    maxLength: 7,
    validate: [required.postCode, max.lengthPostCode(7), restrictChineseCharacters, caPostcode],
  },
  {
    ...companyName,
    validate: [max.lengthCompany(35), restrictChineseCharacters],
  },
  {
    ...nameNumber,
    label: 'checkout.delivery.address.field.label.buildingNumberName.text',
    validate: [required.houseNumber, max.lengthHouseNumber(32), restrictChineseCharacters],
  },
  {
    ...streetName,
    label: 'checkout.delivery.address.field.label.addressStreet.text',
    validate: [required.address1, max.lengthAddress(35), restrictChineseCharacters],
  },
  {
    ...addressLine2,
    label: 'checkout.delivery.address.field.label.additionalAddressNumberOrFloor.text',
    validate: [max.lengthAddress(35), restrictChineseCharacters],
  },
  {
    ...townCity,
    validate: [required.townCity, max.lengthAddress(35), restrictChineseCharacters],
  },
  {
    name: 'county',
    label: 'checkout.delivery.address.field.label.stateOrProvince.text',
    element: 'select',
    required: true,
    validate: [required.state],
    options: [
      {value: 'AB', content: 'Alberta'},
      {value: 'BC', content: 'British Columbia'},
      {value: 'MB', content: 'Manitoba'},
      {value: 'NB', content: 'New Brunswick'},
      {value: 'NL', content: 'Newfoundland and Labrador'},
      {value: 'NS', content: 'Nova Scotia'},
      {value: 'NT', content: 'Northwest Territories'},
      {value: 'NU', content: 'Nunavut'},
      {value: 'ON', content: 'Ontario'},
      {value: 'PE', content: 'Prince Edward Island'},
      {value: 'QC', content: 'Quebec'},
      {value: 'SK', content: 'Saskatchewan'},
      {value: 'YT', content: 'Yukon'},
    ],
  },
];

const FieldDefinitionCADefaultWithStateAutocomplete = [
  {
    ...addressee,
    validate: [required.fullName, max.lengthAddressee(35), restrictChineseCharacters],
  },
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    transform: formatCAPostcode,
    maxLength: 7,
    validate: [required.postCode, max.lengthPostCode(7), restrictChineseCharacters, caPostcode],
  },
  {
    ...companyName,
    validate: [max.lengthCompany(35), restrictChineseCharacters],
  },
  {
    ...nameNumber,
    label: 'checkout.delivery.address.field.label.buildingNumberName.text',
    validate: [required.houseNumber, max.lengthHouseNumber(32), restrictChineseCharacters],
  },
  {
    ...streetName,
    label: 'checkout.delivery.address.field.label.addressStreet.text',
    validate: [required.address1, max.lengthAddress(35), restrictChineseCharacters],
  },
  {
    ...addressLine2,
    label: 'checkout.delivery.address.field.label.additionalAddressNumberOrFloor.text',
    validate: [max.lengthAddress(35), restrictChineseCharacters],
  },
  {
    ...townCity,
    validate: [required.townCity, max.lengthAddress(35), restrictChineseCharacters],
  },
  {
    name: 'county',
    label: 'checkout.address.field.label.county.text',
    required: true,
    element: fieldTypes.AUTOCOMPLETE,
    placeholder: 'checkout.delivery.address.field.placeholder.county.autoComplete',
    predictions: states,
    validate: [required.state, validateAutocompleteField(states, 'state')],
  },
];

const autocompleteConditions = window.start.settings.should_use_autocomplete_for_state;
const FieldDefinitionCA = autocompleteConditions ? FieldDefinitionCADefaultWithStateAutocomplete : FieldDefinitionCADefault;

export default FieldDefinitionCA;
